import { render } from "./DJSets.vue?vue&type=template&id=6b1208ed"
import script from "./DJSets.vue?vue&type=script&lang=js"
export * from "./DJSets.vue?vue&type=script&lang=js"

import "./DJSets.vue?vue&type=style&index=0&id=6b1208ed&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__